import { useHistory, useLocation } from 'react-router-dom';

export const useItemValue = () => {
  const param = 'value';
  const location = useLocation();
  const history = useHistory();
  const searchParams = new URLSearchParams(location.search);

  const itemValue = searchParams.get(param);

  const removeItemValueParam = () => {
    if (!searchParams.has(param)) {
      return;
    }

    searchParams.delete(param);
    history.replace({ search: searchParams.toString() });
  };

  return { itemValue, removeItemValueParam };
};
